import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { prettyDate, fmtHrs } from "@/lib/timesheet";

export const MonthWeeksList = ({ weeks }) => {
  const navigate = useNavigate();
  const open = (w) => navigate(w.timesheet_id ? `/timesheet/${w.timesheet_id}` : `/timesheet/new?week=${w.end}`);
  return (
    <Card className="mt-6 overflow-hidden" data-testid="month-weeks-list">
      <div className="border-b border-border bg-secondary/40 px-5 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Weekly approvals
      </div>
      <ul className="divide-y divide-border">
        {weeks.map((w) => (
          <li key={w.week_ending}>
            <button
              type="button"
              data-testid={`month-week-${w.index}`}
              onClick={() => open(w)}
              className="flex w-full flex-wrap items-center gap-x-6 gap-y-2 px-5 py-4 text-left transition-colors hover:bg-secondary/30"
            >
              <span className="w-20 font-heading text-base font-bold">Week {w.index}</span>
              <span className="min-w-[180px] flex-1 text-sm text-muted-foreground">
                {prettyDate(w.start)} - {prettyDate(w.end)}
                {!w.required && <span className="ml-2 text-xs">(before your start date)</span>}
              </span>
              <span className="w-28 font-mono text-sm tabular" data-testid={`month-week-hours-${w.index}`}>{fmtHrs(w.worked + w.leave)} hrs</span>
              <span data-testid={`month-week-status-${w.index}`}><StatusBadge status={w.status} testId={`month-week-badge-${w.index}`} /></span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>
          </li>
        ))}
      </ul>
    </Card>
  );
};
